module.exports = __webpack_public_path__ + "img/ArgIslan3.cfef488c.jpg";